import { Component, ElementRef, Input, Output, OnChanges, SimpleChanges, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ImportSettingsService } from '../../import-settings.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

declare const JSONEditor;

@Component({
  selector: 'app-add-new-import',
  templateUrl: './add-new-import.component.html',
  styleUrls: ['./add-new-import.component.scss']
})
export class AddNewImportComponent implements OnInit, OnChanges {

  @Output() closeAction: EventEmitter <any> = new EventEmitter<any>();
  @Input() inputData: any;
  @ViewChild('card') card: T2CardComponent;
  @ViewChild('jsonEditorEntity') editorEntity: ElementRef;
  @ViewChild('jsonEditorRules') editorRules: ElementRef;
  rulesJsonForm: FormGroup;
  optionsJsonEditor = {
    modes: [ 'code', 'tree', 'text', 'form', 'view' ]
  };
  tab = 'Entity';
  jsonStructureEntity: any;
  jsonStructureRules: any;

  constructor(
    protected fb: FormBuilder,
    protected service: ImportSettingsService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.buildForm();
  }

  ngOnInit() {
    if (!this.jsonStructureEntity) {
      this.jsonStructureEntity = new JSONEditor(this.editorEntity.nativeElement, this.optionsJsonEditor, {});
    }
    if (!this.jsonStructureRules) {
      this.jsonStructureRules = new JSONEditor(this.editorRules.nativeElement, this.optionsJsonEditor, {});
    }
  }

  buildForm() {
    this.rulesJsonForm = this.fb.group({
      title: ['', [Validators.required]]
    });
  }

  activateTab(option) {
    this.tab = option;
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change['inputData']) {
      if (change['inputData'].currentValue) {
        this.rulesJsonForm.patchValue({
          title: this.inputData.description,
        });
        this.refreshJsonEditorEntity(JSON.parse(this.inputData.entitysetting));
        this.refreshJsonEditorRules(JSON.parse(this.inputData.rulesetting));
      }
    }
  }

  refreshJsonEditorEntity (json) {
    if (!this.jsonStructureEntity) {
      this.jsonStructureEntity = new JSONEditor(
        this.editorEntity.nativeElement,
        this.optionsJsonEditor,
        typeof json !== 'string' ? json : JSON.parse(json)
      );
    } else {
      this.jsonStructureEntity.update(json);
    }
  }

  refreshJsonEditorRules (json) {
    if (!this.jsonStructureRules) {
      this.jsonStructureRules = new JSONEditor(
        this.editorRules.nativeElement,
        this.optionsJsonEditor,
        typeof json !== 'string' ? json : JSON.parse(json)
      );
    } else {
      this.jsonStructureRules.update(json);
    }
  }

  save() {
    this.showSwalDialog('Add new import rule: ' + this.rulesJsonForm.get('title').value, () => {
      this.card.viewProgressBar(true);
      this.service.insertImport(
        {
          description: this.rulesJsonForm.get('title').value,
          entitysetting: JSON.stringify(this.jsonStructureEntity.get()),
          rulesetting: JSON.stringify(this.jsonStructureRules.get())
        }
      ).finally(() => {
        this.card.viewProgressBar(false);
      }).subscribe(
        data => {
          this.showSwal(data.message);
          this.close();
        },
        error => {
        }
      );
    });
  }

  update() {
    this.showSwalDialog('Update import rule: ' + this.rulesJsonForm.get('title').value, () => {
      this.card.viewProgressBar(true);
      this.service.setRuleImport(
        {
          importtypeid: this.inputData.importtypeid,
          description: this.rulesJsonForm.get('title').value,
          entitysetting: JSON.stringify(this.jsonStructureEntity.get()),
          rulesetting: JSON.stringify(this.jsonStructureRules.get()),
          modifiedon: this.inputData.modifiedon,
          addedon: this.inputData.addedon
        }
      ).finally(() => {
        this.card.viewProgressBar(false);
      }).subscribe(
        data => {
          this.showSwal(data.message);
          this.close();
        },
        error => {
        }
      );
    });
  }

  open() {
    this.card.open();
  }

  close(option?: boolean) {
    this.closeAction.emit();
    this.card.close();
  }

  showSwal(message) {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Import Settings',
      type: 'success',
      text: message
    });
  }

  showSwalDialog(text, callback?) {
    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: text,
      type: 'question',
    }).then((result) => {
      if (result.value) {
        callback();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/import-settings/componets/add-new-import/add-new-import.component.ts